/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Tut_Open_1Inputs */

const en_pc_tut_open_1 = /** @type {(inputs: Pc_Tut_Open_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start PdfCraft and drag a PDF onto the window, or click Open. On Windows you can also right-click a PDF and choose “Edit with PdfCraft”.`)
};

const zh_pc_tut_open_1 = /** @type {(inputs: Pc_Tut_Open_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`启动 PdfCraft，把 PDF 拖进窗口，或点击「Open」。在 Windows 上也可以右键 PDF，选择「Edit with PdfCraft」。`)
};

/**
* | output |
* | --- |
* | "Start PdfCraft and drag a PDF onto the window, or click Open. On Windows you can also right-click a PDF and choose “Edit with PdfCraft”." |
*
* @param {Pc_Tut_Open_1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_tut_open_1 = /** @type {((inputs?: Pc_Tut_Open_1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Tut_Open_1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_tut_open_1(inputs)
	return zh_pc_tut_open_1(inputs)
});
export { pc_tut_open_1 as "pc.tut.open.1" }